import { appActions } from '../AppActions'
import AccountTitleRepository from '../../infra/AccountTitleRepository'
import history from '../../util/history'
import AppDispatcher from '../../core/AppDispatcher'
import AccountTitleEvent from '../../event/AccountTitleEvent'

const onRequestDelete = async id => {
  const response = await AccountTitleRepository.requestDeleteByTitleId(id).catch(e => e)
  if (response instanceof Error) {
    appActions.showAlert(response, '削除できませんでした')
    return false
  }

  AppDispatcher.dispatchWithType(AccountTitleEvent.onClear)
  appActions.snackbar('削除しました', 'success', true)
  history.goBack()
  return true
}

export default onRequestDelete
